(function () {
  var T = window.fabT || {};

  /* UAE Dirham Custom SVG Icon */
  var aedSvg = '<span class="custom-currency" style="display:inline-block;vertical-align:-0.12em;line-height:1;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 324.19 290.45" style="width:1em;height:1em;fill:currentColor;"><path d="M324.19,196l-11.564-6.936-35.262.109c-4.33,19.185-12.015,36.87-24.215,52.285-52.205,65.958-150.381,44.876-223.958,48.532,2.849-4.499,5.761-8.708,7.763-13.727,1.821-4.565,5.237-16.258,5.237-20.763v-67.5c-.733-.266-1.196,1-1.5,1h-17c-.439,0-5.271-1.443-6.211-1.789C3.818,182.177-1.094,165.349.2,152c2.935,2.677,10.64,8,14.49,8h27.5v-29h-19.5c-2.219,0-9.47-3.846-11.523-5.477C1.752,118.046-.644,105.426.2,94c2.717,2.386,10.046,8,13.49,8h28.5V35.5c0-3.807-3.689-16.654-5.239-20.761L29.199,0c1.487.774,2.749,1.006,4.438,1.053,53.694,1.484,121.79-8.11,171.229,12.77,37.763,15.949,63.968,47.84,72.42,88.078.965.826,21.558-.319,25.406.096,11.676,1.26,18.623,12.809,21.497,23.003v13c-2.88-1.425-8.525-7-11.5-7h-31.5c-.266.733,1,1.196,1,1.5v25c0,.35-1.774,1.109.5,2.5h22c1.226,0,6.431,3.176,7.826,4.174,6.946,4.973,8.988,11.078,11.674,18.826v13ZM229.19,102c-3.228-25.477-14.198-52.622-35.081-68.419-31.382-23.739-71.896-17.869-108.919-18.581v87h144ZM233.268,131H85.19v29h148.078v-29ZM227.69,189c-46.154,1.783-94.583,0-141,0-.304,0-.767-1.266-1.5-1v87c41.025.035,87.048,4.95,118.024-27.476,12.247-12.821,24.852-40.392,25.994-58.02.202-3.118-1.042-.523-1.518-.505Z"/></svg></span>';

  /* header search: open in place, live results */
  var sbtn = document.getElementById('srchbtn'), spanel = document.getElementById('srchpanel'),
      sinput = document.getElementById('srchinput'), sres = document.getElementById('srchres'), sclose = document.getElementById('srchclose');
  if (sbtn && spanel && sinput) {
    var st, lastQ = '';
    function openS() { spanel.hidden = false; sbtn.setAttribute('aria-expanded', 'true'); setTimeout(function () { sinput.focus(); }, 30); }
    function closeS() { spanel.hidden = true; sbtn.setAttribute('aria-expanded', 'false'); }
    sbtn.addEventListener('click', function () { spanel.hidden ? openS() : closeS(); });
    if (sclose) sclose.addEventListener('click', closeS);
    addEventListener('keydown', function (e) { if (e.key === 'Escape' && !spanel.hidden) closeS(); });
    document.addEventListener('click', function (e) { if (!spanel.hidden && !spanel.contains(e.target) && !sbtn.contains(e.target)) closeS(); });
    function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    sinput.addEventListener('input', function () {
      var q = sinput.value.trim();
      clearTimeout(st);
      if (q.length < 2) { sres.innerHTML = ''; lastQ = ''; return; }
      st = setTimeout(function () {
        lastQ = q;
        fetch(window.Shopify.routes.root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (q !== lastQ) return;
            var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!ps.length) { sres.innerHTML = '<p class="srchnone">' + (T.no_results || 'No products found for “%s”').replace('%s', esc(q)) + '</p>'; return; }
            sres.innerHTML = '<ul>' + ps.map(function (p) {
              var img = p.image ? '<img src="' + p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy">' : '<span class="ph"></span>';
              var priceText = esc(p.price).replace(/Dhs\.?|AED/gi, '').trim();
              return '<li><a href="' + p.url + '">' + img + '<span><b>' + esc(p.title) + '</b><em>' + aedSvg + ' ' + priceText + '</em></span></a></li>';
            }).join('') + '</ul><a class="srchall" href="' + window.Shopify.routes.root + 'search?type=product&q=' + encodeURIComponent(q) + '">' + (T.see_all || 'See all results') + '</a>';
          }).catch(function () {});
      }, 180);
    });
  }

  /* footer: columns collapse into accordions on phones */
  var fcols = document.querySelectorAll('.ftr details.fcol');
  if (fcols.length) {
    var mq = window.matchMedia('(max-width:749px)');
    function setF() { fcols.forEach(function (d) { if (mq.matches) d.removeAttribute('open'); else d.setAttribute('open', ''); }); }
    setF();
    if (mq.addEventListener) mq.addEventListener('change', setF);
    fcols.forEach(function (d) { d.querySelector('summary').addEventListener('click', function (e) { if (!mq.matches) e.preventDefault(); }); });
  }

  /* slide-out bag */
  var drawer = document.getElementById('cartdrawer');
  if (drawer) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var cdBody = drawer.querySelector('.cd-body'), cdFoot = drawer.querySelector('.cd-foot'), cdCount = drawer.querySelector('.cd-count');
    var FREE = 50000;

    /* Updated money function: returns SVG icon + formatted amount */
    function money(c) {
      var n = (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return aedSvg + ' ' + n;
    }

    function e2(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    
    function render(c) {
      document.querySelectorAll('[data-bag-count]').forEach(function (el) { el.textContent = c.item_count; });
      if (cdCount) cdCount.textContent = c.item_count ? '(' + c.item_count + ')' : '';
      if (!c.items.length) {
        cdBody.innerHTML = '<div class="cd-empty"><p>' + (T.empty || 'Your bag is empty.') + '</p><a class="btn" href="' + root + 'collections/new-arrivals">' + (T.shop_new || 'Shop new arrivals') + '</a></div>';
        cdFoot.hidden = true; return;
      }
      var left = FREE - c.total_price, pct = Math.min(100, Math.round(c.total_price / FREE * 100));
      var bar = '<div class="cd-free"><p>' + (left > 0 ? (T.free_left || 'Add <b>%a</b> more for free delivery').replace('%a', money(left)) : (T.free_done || 'You\u2019ve got <b>free delivery</b>')) + '</p><span><i style="width:' + pct + '%"></i></span></div>';
      cdBody.innerHTML = bar + '<ul class="cd-items">' + c.items.map(function (it) {
        var img = it.image ? '<img src="' + it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=180" alt="" loading="lazy">' : '';
        var vt = it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + e2(it.variant_title) + '</small>' : '';
        return '<li data-key="' + it.key + '"><a href="' + it.url + '" class="cd-img">' + img + '</a><div class="cd-info"><a href="' + it.url + '">' + e2(it.product_title) + '</a>' + vt +
          '<div class="cd-row"><div class="cd-qty"><button type="button" data-q="' + (it.quantity - 1) + '" aria-label="Decrease">\u2212</button><span>' + it.quantity + '</span><button type="button" data-q="' + (it.quantity + 1) + '" aria-label="Increase">+</button></div><b>' + money(it.final_line_price) + '</b></div>' +
          '<button type="button" class="cd-rm" data-q="0">' + (T.remove || 'Remove') + '</button></div></li>';
      }).join('') + '</ul>';
      cdFoot.hidden = false;

      /* Changed from .textContent to .innerHTML taake SVG parse ho sake */
      var subTotalEl = cdFoot.querySelector('.cd-sub b');
      if (subTotalEl) subTotalEl.innerHTML = money(c.total_price);
    }

    function load() { return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(render).catch(function () {}); }
    function openD() {
      load(); drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('on'); });
      document.documentElement.style.overflow = 'hidden';
    }
    function closeD() {
      drawer.classList.remove('on'); document.documentElement.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; }, 320);
    }
    document.addEventListener('fab:added', openD);
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer || e.target.closest('.cd-close')) { closeD(); return; }
      var b = e.target.closest('[data-q]'); if (!b) return;
      var li = b.closest('li'); if (!li) return;
      li.classList.add('busy');
      fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: li.dataset.key, quantity: parseInt(b.dataset.q, 10) }) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) { if (!res.ok) { window.fabToast && fabToast(res.d.description || 'Not enough stock'); load(); } else render(res.d); })
        .catch(load);
    });
    addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) closeD(); });
    if (!/\/cart\/?$/.test(location.pathname)) {
      document.querySelectorAll('a.bag').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); openD(); }); });
    }
  }
})();